import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class IncidentStatusService {
  static async getAll() {
    const { data } = await DataService.get(API.servicesStatus.root);
    return {
        serviceStatus: data.serviceStatus,
    };
  }
}


export { IncidentStatusService };
